import React, { useEffect, useState, useRef, useMemo } from "react";
import EditIcon from "@material-ui/icons/Edit";
import {
  makeStyles,
  Grid,
  Box,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  viewRatePopupBtn: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  saveBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "8px",
  },

  updateBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },

  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },

  table: {
    width: "100%",
    marginTop: theme.spacing(1),
    borderCollapse: "collapse",
    backgroundColor: "#e6eaeb", // Milky white background for the table
  },
  tableCellInput: {
    width: "100%",
    padding: "5px",
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: "auto",
  },
  tableHeader: {
    backgroundColor: "#01539a",
    color: "white",
    fontWeight: "bold",
  },
  tableCell: {
    padding: theme.spacing(1),
    textAlign: "left",
  },
  zebraRow: {
    backgroundColor: "#f5f5f5",
  },
  zebraRowDark: {
    backgroundColor: "#fff",
  },
  closeSection: {
    position: "absolute",
    cursor: "pointer",
    right: theme.spacing(0.25),
    top: theme.spacing(0.25),
  },
  closeIcon: {
    color: "#C4C4C4",
  },
}));

const PipelineRates = ({
  showDialogViewRates,
  onCloseViewRates,
  tableEditable,
  setTableEditable,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [ratesData, setRatesData] = useState({
    directorLabor: 25.2,
    subcontractor: 25.15,
    odcs: 31.1,
  });

  const onUpdateViewRates = () => {
    setTableEditable(false);
  };

  const onCancelViewRatesEditable = () => {
    setTableEditable(false);
  };

  const onViewRatesInputChange = (newValue, fieldName) => {
    const updatedData = JSON.parse(JSON.stringify(ratesData));
    if (newValue === "") {
      updatedData[fieldName] = 0;
    } else if (!isNaN(newValue)) {
      updatedData[fieldName] = parseFloat(newValue);
    }
    setRatesData(updatedData);
  };

  return (
    <>
      {" "}
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="lg"
        aria-labelledby="confirmation-dialog"
        open={showDialogViewRates}
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span className={classes.closeIconAdd} onClick={onCloseViewRates}>
              x
            </span>
            <div className={classes.addColumnTitle}>View Rates</div>
          </div>
          {tableEditable ? (
            <div className={classes.viewRatePopupBtn}>
              <span className={classes.updateBtn} onClick={onUpdateViewRates}>
                {" "}
                Update{" "}
              </span>
              <span
                className={classes.cancelBtn}
                onClick={onCancelViewRatesEditable}
              >
                {" "}
                Cancel{" "}
              </span>
            </div>
          ) : (
            <div className={classes.viewRatePopupBtn}>
              <div
                className={classes.editBtn}
                onClick={() => setTableEditable(true)}
              >
                <EditIcon className={classes.editIcon} />
                <span className={classes.editText}> Edit </span>
              </div>
            </div>
          )}
          <table className={classes.table}>
            <thead>
              <tr className={classes.tableHeader}>
                <th className={classes.tableCell}>
                  <strong>Direct Labor%</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>Subcontractor%</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>ODCs%</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.tableCell}>
                  {tableEditable ? (
                    <input
                      onChange={(e) =>
                        onViewRatesInputChange(e.target.value, "directorLabor")
                      }
                      className={classes.tableCellInput}
                      value={
                        isNaN(ratesData.directorLabor)
                          ? 0
                          : ratesData.directorLabor
                      }
                      type="number"
                    />
                  ) : (
                    `${
                      isNaN(ratesData.directorLabor)
                        ? 0
                        : ratesData.directorLabor
                    }%`
                  )}
                </td>
                <td className={classes.tableCell}>
                  {tableEditable ? (
                    <input
                      onChange={(e) =>
                        onViewRatesInputChange(e.target.value, "subcontractor")
                      }
                      className={classes.tableCellInput}
                      value={
                        isNaN(ratesData.subcontractor)
                          ? 0
                          : ratesData.subcontractor
                      }
                      type="number"
                    />
                  ) : (
                    `${
                      isNaN(ratesData.subcontractor)
                        ? 0
                        : ratesData.subcontractor
                    }%`
                  )}
                </td>
                <td className={classes.tableCell}>
                  {tableEditable ? (
                    <input
                      onChange={(e) =>
                        onViewRatesInputChange(e.target.value, "odcs")
                      }
                      className={classes.tableCellInput}
                      value={isNaN(ratesData.odcs) ? 0 : ratesData.odcs}
                      type="number"
                    />
                  ) : (
                    `${isNaN(ratesData.odcs) ? 0 : ratesData.odcs}%`
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PipelineRates;
